import { atom } from 'jotai';

export const v2SupportedDestinationsModalConfirmDisabledAtom = atom(true);
